import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    demoTitle: {
        paddingTop: theme.spacing(0.5),
    },
}));

export default useStyles;
